import { render, staticRenderFns } from "./plan-folder.vue?vue&type=template&id=fcde2348&scoped=true"
import script from "./plan-folder.vue?vue&type=script&lang=ts"
export * from "./plan-folder.vue?vue&type=script&lang=ts"
import style0 from "./plan-folder.vue?vue&type=style&index=0&id=fcde2348&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcde2348",
  null
  
)

export default component.exports